import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={styles.container}>
      <h1>Privacy Policy – Freshcart</h1>
      <p><strong>Last Updated:</strong> January 2026</p>

      <p>
        Freshcart respects your privacy and is committed to protecting your
        personal information. This Privacy Policy explains how we collect, use,
        and safeguard your data when you use the Freshcart mobile application
        and website.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Name</li>
        <li>Phone Number</li>
        <li>Delivery Address</li>
        <li>Order Details</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To process and deliver your orders</li>
        <li>To contact you regarding your orders</li>
        <li>To provide customer support</li>
        <li>To improve our services and user experience</li>
      </ul>

      <h2>3. Data Sharing Policy</h2>
      <p>
        Freshcart does not sell, trade, or rent your personal information to
        any third party. Your data is used only for order processing and service
        improvement.
      </p>

      <h2>4. Payment Information</h2>
      <p>
        All payments made through UPI or Cash on Delivery are secure. Freshcart
        does not store any bank account or UPI details on its servers.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We take appropriate security measures to protect your personal
        information from unauthorized access, alteration, disclosure, or
        destruction.
      </p>

      <h2>6. Permissions Used</h2>
      <ul>
        <li>Internet access – to load data and process orders</li>
        <li>Location (if enabled) – to detect delivery address easily</li>
      </ul>

      <h2>7. Children's Privacy</h2>
      <p>
        Freshcart does not knowingly collect data from children under the age of
        13. If we become aware of such data, we will delete it immediately.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        Email:{" "}
        <a href="mailto:vishalthakurktrr44@gmail.com">
          vishalthakurktr44@gmail.com
        </a>
        <br />
        Website:{" "}
        <a href="https://freshcart4u.com" target="_blank" rel="noreferrer">
          https://freshcart4u.com
        </a>
      </p>

      <p>By using Freshcart, you agree to this Privacy Policy.</p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "900px",
    margin: "40px auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.8",
    color: "#333",
  },
};

export default PrivacyPolicy;